// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./index.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/typography/HUNTERREGULAR.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/typography/EUCLIDFLEX.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/typography/EUCLIDFLEXLIGHT.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'hunter-regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
  font-family: 'euclid_flex-regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
  font-family: 'euclid_flex-light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

:root {
  --background-light: #ffffff;
  --background-dark: #000000;
  --background-transparent: rgba(0, 0, 0, 0);
  --text-light: #ffffff;
  --text-dark: #000000;
  --pink-nav: #ff008c;
  --pink-banner: #DA2F86;
  --pink-mid: #DA2F86;
  --item-link: #da267d;
  --item-hover: #ff008c;
  --item-bold: #da267d;
  --item-disabled: #7c7c7c;
  --primary: #23272d;
  --secondary: #EEB9B8;
  --sd-pink: #C62F7C;
  --sd-peach: #D89280;
  --sd-cream: #E7B4B0;
  --sd-yellow: #EACB67;
  --sd-aqua: #4DADAB;
  --sd-heather: #C0D4D1;
  --sd-bg-cream: #EFD1B9;
  --sd-heather-grey: #C4BABA;
  --button-border: #000000;
  --gradient: linear-gradient(45deg,
      rgba(54, 54, 54, 0.8) 0%,
      rgba(88, 88, 88, 0.7) 100%);
  --gradient-light: linear-gradient(45deg,
      rgba(158, 158, 158, 0.8) 0%,
      rgba(255, 255, 255, 0.7) 100%);
}

*,
*::before,
*::after {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

html {
  scroll-behavior: smooth;
  overflow-x: hidden;
}

body {
  font-family: 'euclid_flex-regular', sans-serif;
  line-height: 1.5;
  font-size: 16px;
  background-color: var(--background-light);
  color: var(--text-dark);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
}

.body-dark-mode {
  color: var(--text-light);
  background-color: var(--background-dark);
}

header {
  z-index: 99;
}

h1 {
  font-family: "hunter-regular", "Baskerville", sans-serif;
}

h2, h3 {
  font-family: "euclid_flex-light", sans-serif;
}


p {
  font-family: "euclid_flex-regular", sans-serif;
  font-weight: 400;
}

b {
  color: var(--item-bold);
  font-weight: 900;
  letter-spacing: 2px;
}

.layout-test {
  border: 1px solid rgb(255, 0, 183);
}

.layout-test * {
  border: 1px solid rgb(183, 0, 255);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,6BAA6B;EAC7B,+DAAyE;AAC3E;;AAEA;EACE,kCAAkC;EAClC,+DAAsE;AACxE;;AAEA;EACE,gCAAgC;EAChC,+DAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,0CAA0C;EAC1C,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB;;iCAE+B;EAC/B;;oCAEkC;AACpC;;AAEA;;;EAGE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,4CAA4C;AAC9C;;;AAGA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["@import './index.css';\n\n@font-face {\n  font-family: 'hunter-regular';\n  src: url('../src/assets/typography/HUNTERREGULAR.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'euclid_flex-regular';\n  src: url('../src/assets/typography/EUCLIDFLEX.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'euclid_flex-light';\n  src: url('../src/assets/typography/EUCLIDFLEXLIGHT.ttf') format('truetype');\n}\n\n:root {\n  --background-light: #ffffff;\n  --background-dark: #000000;\n  --background-transparent: rgba(0, 0, 0, 0);\n  --text-light: #ffffff;\n  --text-dark: #000000;\n  --pink-nav: #ff008c;\n  --pink-banner: #DA2F86;\n  --pink-mid: #DA2F86;\n  --item-link: #da267d;\n  --item-hover: #ff008c;\n  --item-bold: #da267d;\n  --item-disabled: #7c7c7c;\n  --primary: #23272d;\n  --secondary: #EEB9B8;\n  --sd-pink: #C62F7C;\n  --sd-peach: #D89280;\n  --sd-cream: #E7B4B0;\n  --sd-yellow: #EACB67;\n  --sd-aqua: #4DADAB;\n  --sd-heather: #C0D4D1;\n  --sd-bg-cream: #EFD1B9;\n  --sd-heather-grey: #C4BABA;\n  --button-border: #000000;\n  --gradient: linear-gradient(45deg,\n      rgba(54, 54, 54, 0.8) 0%,\n      rgba(88, 88, 88, 0.7) 100%);\n  --gradient-light: linear-gradient(45deg,\n      rgba(158, 158, 158, 0.8) 0%,\n      rgba(255, 255, 255, 0.7) 100%);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  overflow-x: hidden;\n}\n\nbody {\n  font-family: 'euclid_flex-regular', sans-serif;\n  line-height: 1.5;\n  font-size: 16px;\n  background-color: var(--background-light);\n  color: var(--text-dark);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow: hidden;\n  overflow-y: auto;\n  position: relative;\n  -webkit-overflow-scrolling: touch;\n}\n\n.body-dark-mode {\n  color: var(--text-light);\n  background-color: var(--background-dark);\n}\n\nheader {\n  z-index: 99;\n}\n\nh1 {\n  font-family: \"hunter-regular\", \"Baskerville\", sans-serif;\n}\n\nh2, h3 {\n  font-family: \"euclid_flex-light\", sans-serif;\n}\n\n\np {\n  font-family: \"euclid_flex-regular\", sans-serif;\n  font-weight: 400;\n}\n\nb {\n  color: var(--item-bold);\n  font-weight: 900;\n  letter-spacing: 2px;\n}\n\n.layout-test {\n  border: 1px solid rgb(255, 0, 183);\n}\n\n.layout-test * {\n  border: 1px solid rgb(183, 0, 255);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
